import { Sidebar, SidebarContent, SidebarRail } from "@/components/ui/sidebar";
import { NavGroup } from "@/components/layouts/nav-group";
import { applicantProcessingSidebarData } from "./data/applicant-processing-sidebar-data";

export function ApplicantProcessingSidebar({
  ...props
}: React.ComponentProps<typeof Sidebar>) {
  return (
    <Sidebar collapsible="icon" variant="sidebar" {...props}>
      <SidebarContent>
        {applicantProcessingSidebarData.navGroups.map((props, index) => (
          <NavGroup key={index} {...props} />
        ))}
      </SidebarContent>
      <SidebarRail />
    </Sidebar>
  );
}
